// Server-side sort on the list tables (C2, 01/11/2026).
//
// Each list column used to be matched to a header click by the LAST segment of its db_field, so columns
// that share one (Quotations: Created By / Updated By / Chase By all end in "fullName") could sort by the
// wrong column and emit more than one sort. A column whose last segment is shared now gets its own sort
// key (last segment + "#" + column id); every other column keeps the plain last segment, as before.
// The emitted sortField is still the last segment; the column is identified by its id.

export function lastSegment(dbField) {
  const a = String(dbField == null ? '' : dbField).split('.')
  return a[a.length - 1]
}

function sharesLastSegment(col, cols) {
  const last = lastSegment(col.dbField)
  return (cols || []).filter(c => c && lastSegment(c.dbField) === last).length > 1
}

// The value bound to <Column :sortField>; PrimeVue sends it back as event.sortField.
export function columnSortKey(col, cols) {
  const last = lastSegment(col.dbField)
  return sharesLastSegment(col, cols) ? last + '#' + col.id : last
}

// The one column a header click refers to, or null. Falls back to the first column with that last
// segment, for the fixed columns outside the loop (e.g. Users "status", Enquiries "oppStatusName").
export function findSortColumn(sortField, cols) {
  if (!sortField) return null
  const list = (cols || []).filter(c => c && c.dbField != null)
  return list.find(c => columnSortKey(c, list) === sortField) ||
    list.find(c => lastSegment(c.dbField) === sortField) ||
    null
}

// The sortChange payload for a header click: exactly one, or null when no column matches.
export function sortChangeFor(event, cols) {
  const col = findSortColumn(event && event.sortField, cols)
  if (!col) return null
  return { sortField: lastSegment(col.dbField), sortFieldId: col.id, sortOrder: event.sortOrder }
}

// The DataTable sortField to show after a reload, from the saved sortField + sortFieldId.
export function restoreSortKey(sortField, sortFieldId, cols) {
  if (!sortField) return sortField
  const list = (cols || []).filter(c => c && c.dbField != null)
  const col = list.find(c => String(c.id) === String(sortFieldId) && lastSegment(c.dbField) === sortField)
  return col ? columnSortKey(col, list) : sortField
}
